import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Uses localStorage
import { combineReducers } from '@reduxjs/toolkit';

import { chatApi } from 'src/pages/chat/slice/chatApi';
import { authApi } from 'src/pages/auth/slice/authApi';
import { ticketApi } from 'src/pages/tickets/slice/ticketApi';
import { tenantApi } from 'src/pages/tenants/slice/tenantsApi';
import { channelApi } from 'src/pages/channel/slice/channelApi';
import { settingApi } from 'src/pages/setting/slice/settingApi';
import { accountAPi } from 'src/pages/accounts/slice/accountsApi';
import { contactsApi } from 'src/pages/contacts/slice/contactsApi';
import { campaignApi } from 'src/pages/campaign/slice/campaignApi';
import { dashboardApi } from 'src/pages/dashborad/slice/dashboardApi';
import { agentApi } from 'src/pages/automation/agents/slice/agentApi';
import { aiAgentInboxApi } from 'src/pages/chat/slice/aiAgentInboxApi';
import { workflowApi } from 'src/pages/automation/workflow/slice/workflowApi';
import { agentLearningApi } from 'src/pages/automation/agents/slice/agentLearningApi';

import { kanbanApi } from 'src/components/kanban/slice/kanbanApi';

import authSlice from '../pages/auth/slice/authSlice';
import chatSlice from '../pages/chat/slice/chatSlice';
import userPresenceReducer from './slices/userPresenceSlice';
import channelSlice from '../pages/channel/slice/channelSlice';
import settingSlice from '../pages/setting/slice/settingSlice';
import accountSlice from '../pages/accounts/slice/accountSlice';
import contactsSlice from '../pages/contacts/slice/contactSlice';
import agentAssistSlice from '../pages/chat/slice/agentAssistSlice';
import billingSlice from '../pages/setting/components/billing/slice/billingSlice';
import aiSettingsSlice from '../pages/setting/components/ai-settings/slice/aiSettingsSlice';

// Configuration for redux-persist
const persistConfig = {
  key: 'root', // Key to store data
  storage, // Where to store (localStorage in this case)
  whitelist: ['auth'], // ✅ Persist only "auth"
};

const rootReducer = combineReducers({
  auth: authSlice,
  contact: contactsSlice,
  account: accountSlice,
  chat: chatSlice,
  channel: channelSlice,
  setting: settingSlice,
  billing: billingSlice,
  agentAssist: agentAssistSlice,
  aiSettings: aiSettingsSlice,
  userPresence: userPresenceReducer,
  [accountAPi.reducerPath]: accountAPi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [channelApi.reducerPath]: channelApi.reducer,
  [contactsApi.reducerPath]: contactsApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [settingApi.reducerPath]: settingApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [tenantApi.reducerPath]: tenantApi.reducer,
  [campaignApi.reducerPath]: campaignApi.reducer,
  [ticketApi.reducerPath]: ticketApi.reducer,
  [workflowApi.reducerPath]: workflowApi.reducer,
  [agentApi.reducerPath]: agentApi.reducer,
  [agentLearningApi.reducerPath]: agentLearningApi.reducer,
  [aiAgentInboxApi.reducerPath]: aiAgentInboxApi.reducer,
  [kanbanApi.reducerPath]: kanbanApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
